import KeyMirror from "keymirror";

export default KeyMirror({
  SEND_MAIL: null,
  SEND_MAIL_SUCCESS: null,
  SEND_MAIL_ERROR: null,
});
